import { Box, Grid, Skeleton } from "@mui/material";

export default function DepositFormSkeleton() {
  return (
    <Grid container>
      <Grid xs={12} item>
        <Box py={2}>
          <Skeleton variant="rounded" height={15} width="40%"></Skeleton>
        </Box>

        <Box py={1}>
          <Skeleton variant="rounded" height={10} width="20%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box py={2}>
          <Skeleton variant="rounded" height={20} width="40%"></Skeleton>
        </Box>

        <Box py={1}>
          <Skeleton variant="rounded" height={10} width="25%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box>
          <Skeleton variant="rounded" height={40} width="100%"></Skeleton>
        </Box>

        <Box py={1} dir="rtl">
          <Skeleton variant="rounded" height={10} width="40%"></Skeleton>
        </Box>

        <Box dir="rtl">
          <Skeleton variant="rounded" height={10} width="30%"></Skeleton>
        </Box>
      </Grid>
    </Grid>
  );
}
